export default "__VITE_ASSET__mxuGWWDk__"